import LocalStorageService from 'app/services/localStorage';
import ImagePath from 'app/utilities/imagePath';

const user = LocalStorageService.getUsername();

export const atmIcon = {
    imageSrc: ImagePath.atmIcon.src,
    imageAlt: ImagePath.atmIcon.alt
};

export const internetBankingIcon = {
    imageSrc: ImagePath.globe.src,
    imageAlt: ImagePath.globe.alt
};

export const mobileBankingIcon = {
    imageSrc: ImagePath.handphone.src,
    imageAlt: ImagePath.handphone.alt
};

export const tellerIcon = {
    imageSrc: ImagePath.teller.src,
    imageAlt: ImagePath.teller.alt
};
 // eslint-disable-next-line @typescript-eslint/no-explicit-any
export function accordionData(methodPayment:number): any {
    return [
        {
            title: "ATM",
            type: "ATM",
            imageSrc: atmIcon.imageSrc,
            imageAlt: atmIcon.imageAlt,
            content: [
                "Masukkan kartu ATM",
                "Masukkan PIN ATM Anda",
                "Pilih <b>transaksi lain</b>",
                `Pilih <b>Transfer</b> jika Anda mentransfer dari 
                <b>${methodPayment === 1 ? 'Bank Negara Indonesia (BNI)' : ' Bank Sinarmas'}</b>, 
                pilih <b>“Transfer ke Bank Lain”</b> 
                jika Anda mentransfer dari bank selain ${methodPayment === 1 ? 'Bank Negara Indonesia (BNI)' : ' Bank Sinarmas'}`,
                "Masukkan 15 digit nomor virtual account Anda, lalu pilih <b>benar</b>",
                "Masukkan jumlah nominal yang ingin ditransfer, lalu pilih <b>benar</b>",
                "Pastikan nomor rekening tujuan sudah sesuai dengan nomor virtual account Anda, lalu pilih <b>ya</b>",
                "Transaksi Anda berhasil. Simpan bukti transaksi",
                "Tunggu sampai dana Anda masuk ke Dana Siaga",
            ]
        },
        {
            title: "Internet Banking",
            type: "INTERNET BANKING",
            imageSrc: internetBankingIcon.imageSrc,
            imageAlt: internetBankingIcon.imageAlt,
            content: [
                "Masuk ke akun Anda lewat internet banking",
                "Masukan <b>ID pengguna</b> dan <b>kata sandi</b>",
                "Pilih “transfer”",
                `Pilih <b>Transfer</b> jika Anda mentransfer dari 
                <b>${methodPayment === 1 ? 'Bank Negara Indonesia (BNI)' : ' Bank Sinarmas'}</b>, 
                pilih <b>“Transfer ke Bank Lain”</b> 
                jika Anda mentransfer dari bank selain ${methodPayment === 1 ? 'Bank Negara Indonesia (BNI)' : ' Bank Sinarmas'}`,
                "Masukkan 15 digit nomor virtual account Anda, lalu pilih <b>benar</b>",
                "Masukkan jumlah nominal yang ingin didepositkan ke Dana Siaga Anda, lalu pilih <b>benar</b>",
                "Pastikan nomor rekening tujuan sudah sesuai dengan nomor virtual account Anda",
                "Masukkan kode otentikasi",
                "Tunggu sampai dana Anda masuk ke Dana Siaga",
            ]
        },
        {
            title: "Mobile Banking",
            type: "MOBILE BANKING",
            imageSrc: mobileBankingIcon.imageSrc,
            imageAlt: mobileBankingIcon.imageAlt,
            content: [
                "Buka aplikasi mobile banking di HP Anda dan masukkan <b>nama pengguna</b> dan <b>kata sandi</b> Anda",
                "Pilih “transfer”",
                `Pilih <b>Transfer</b> jika Anda mentransfer dari 
                <b>${methodPayment === 1 ? 'Bank Negara Indonesia (BNI)' : ' Bank Sinarmas'}</b>, 
                pilih <b>“Transfer ke Bank Lain”</b> 
                jika Anda mentransfer dari bank selain ${methodPayment === 1 ? 'Bank Negara Indonesia (BNI)' : ' Bank Sinarmas'}`,
                "Masukkan 15 digit nomor virtual account Anda, lalu pilih <b>benar</b>",
                "Masukkan jumlah nominal yang ingin didepositkan ke Dana Siaga Anda",
                "Pastikan nomor rekening tujuan sudah sesuai dengan nomor virtual account Anda",
                "Transaksi Anda berhasil. Simpan bukti transaksi",
                "Tunggu sampai dana Anda masuk ke Dana Siaga",
            ]
        },
        {
            title: "Teller",
            type: "TELLER",
            imageSrc: tellerIcon.imageSrc,
            imageAlt: tellerIcon.imageAlt,
            content: [
                `Datang ke cabang ${methodPayment === 1 ? 'Bank Negara Indonesia (BNI)' : ' Bank Sinarmas'} terdekat. 
                Siapkan uang cash atau buku tabungan, KTP, dan kartu ATM`,
                "Isi formulir deposit/transfer sesama bank",
                "Tuliskan 15 digit nomor virtual account Anda",
                // eslint-disable-next-line no-useless-concat
                `${"Tuliskan nama penerima <b>“Bpk. </b>" + "<b>"}${user}</b>` + `”`,
                "Tuliskan jumlah dana yang ingin Anda depositkan",
                "Teller akan membantu Anda untuk memproses transaksi",
                "Simpan bukti transaksi",
                "Tunggu sampai dana Anda masuk ke Dana Siaga"
            ]
        }
    ];
}
